"use client"

import { FC, useEffect, useState } from "react"
import Link from "next/link"
import { useLanguage } from "@/src/context/LanguageContext"
import { useUI } from "@/src/lib/i18n/ui"

const COOKIE_KEY = "obelisk_cookie_consent"

const CookieBanner: FC = () => {
  const [visible, setVisible] = useState(false)
  const { lang } = useLanguage()
  const t = useUI(lang)

  useEffect(() => {
    const consent = localStorage.getItem(COOKIE_KEY)
    if (!consent) setVisible(true)
  }, [])

  const accept = () => {
    localStorage.setItem(COOKIE_KEY, "accepted")
    setVisible(false)
  }

  const decline = () => {
    localStorage.setItem(COOKIE_KEY, "declined")
    setVisible(false)
  }

  if (!visible) return null

  return (
    <div
      role="dialog"
      aria-label={t("cookieText")}
      className="fixed bottom-0 left-0 right-0 z-50 bg-[#0a0a0a] border-t border-gray-800 px-4 py-4 md:px-8"
    >
      <div className="container mx-auto flex flex-col md:flex-row md:items-center md:justify-between gap-4">
        <p className="text-gray-400 text-sm font-light leading-relaxed">
          {t("cookieText")}{" "}
          <Link
            href="/privacy-policy"
            className="text-white underline underline-offset-2 hover:text-gray-300 transition-colors"
          >
            {t("cookiePrivacyLink")}
          </Link>
          .
        </p>
        <div className="flex items-center gap-3 flex-shrink-0">
          <button
            onClick={accept}
            className="px-5 py-2 bg-white text-black text-sm font-medium rounded-lg hover:bg-gray-200 transition-colors focus:outline-none focus:ring-1 focus:ring-white focus:ring-offset-1 focus:ring-offset-black"
          >
            {t("cookieAccept")}
          </button>
          <button
            onClick={decline}
            className="px-5 py-2 border border-gray-700 text-gray-400 text-sm font-light rounded-lg hover:border-gray-500 hover:text-white transition-colors focus:outline-none focus:ring-1 focus:ring-gray-700 focus:ring-offset-1 focus:ring-offset-black"
          >
            {t("cookieDecline")}
          </button>
        </div>
      </div>
    </div>
  )
}

export default CookieBanner
